export interface ProfileViewChartData {
  date: number
  views: number
}

export interface ProfileViewsResponse {
  chartData?: {
    data: ProfileViewChartData[]
    views: number
    profileIds: string[]
  }

  totalViews: number
  profileIds: string[]
}

export interface ProfileViewsRequestParams {
  startDate?: number
  endDate?: number
}

export const ANONYMOUS_VIEWER_ID = 'AnonymousViewer'
